/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_Support_Link_TextInputs */

const en_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit the Brave help center`)
};

const id_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungi pusat bantuan Brave`)
};

const ms_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lawati pusat bantuan Brave`)
};

const ca_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita el centre d'ajuda de Brave`)
};

const cs_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navštivte centrum nápovědy Brave`)
};

const da_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besøg Braves hjælpecenter`)
};

const de_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuche das Brave Help Center`)
};

const et_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Külastage Brave'i abikeskust`)
};

const es_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra al Centro de Ayuda de Brave`)
};

const fr_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accéder au centre d’aide Brave`)
};

const hr_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posjetite centar za pomoć brave`)
};

const it_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita il Centro assistenza di Brave`)
};

const lv_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apmeklējiet Brave palīdzības centru`)
};

const lt_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apsilankykite „Brave“ pagalbos centre`)
};

const hu_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Látogasson el a Brave Súgóközpontba`)
};

const nl_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar het Brave Helpcentrum`)
};

const nb_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besøk Braves hjelpesenter`)
};

const pl_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwiedź centrum pomocy Brave`)
};

const pt_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse a Central de Ajuda do Brave`)
};

const ro_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizitează centrul de ajutor Brave`)
};

const sk_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navštívte centrum pomoci Brave`)
};

const sl_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiščite središče za pomoč Brave`)
};

const fi_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käy Braven tukikeskuksessa`)
};

const sv_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besök Braves hjälpcenter`)
};

const vi_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập Trung tâm hỗ trợ Brave`)
};

const tr_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave yardım merkezini ziyaret edin`)
};

const el_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επισκεφθείτε το κέντρο βοήθειας του Brave`)
};

const bg_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посети помощния център на Brave`)
};

const ru_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетите центр помощи Brave`)
};

const sr_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посетите Brave-ов центар за помоћ`)
};

const uk_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відвідайте центр допомоги Brave`)
};

const ka_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ეწვიეთ Brave-ის დახმარების ცენტრს`)
};

const hi_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव हेल्प सेंटर पर जाएं`)
};

const th_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปที่ศูนย์ช่วยเหลือของ Brave`)
};

const ko_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 도움말 센터 방문하기`)
};

const zh_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 Brave 帮助中心`)
};

const zh_tw_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往 Brave 支援中心`)
};

const ja_other_support_link_text = /** @type {(inputs: Other_Support_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveヘルプセンターへ`)
};

/**
* | output |
* | --- |
* | "Visit the Brave help center" |
*
* @param {Other_Support_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const other_support_link_text = /** @type {((inputs?: Other_Support_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_Support_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_other_support_link_text(inputs)
	if (locale === "ms") return ms_other_support_link_text(inputs)
	if (locale === "ca") return ca_other_support_link_text(inputs)
	if (locale === "cs") return cs_other_support_link_text(inputs)
	if (locale === "da") return da_other_support_link_text(inputs)
	if (locale === "de") return de_other_support_link_text(inputs)
	if (locale === "et") return et_other_support_link_text(inputs)
	if (locale === "es") return es_other_support_link_text(inputs)
	if (locale === "fr") return fr_other_support_link_text(inputs)
	if (locale === "hr") return hr_other_support_link_text(inputs)
	if (locale === "it") return it_other_support_link_text(inputs)
	if (locale === "lv") return lv_other_support_link_text(inputs)
	if (locale === "lt") return lt_other_support_link_text(inputs)
	if (locale === "hu") return hu_other_support_link_text(inputs)
	if (locale === "nl") return nl_other_support_link_text(inputs)
	if (locale === "nb") return nb_other_support_link_text(inputs)
	if (locale === "pl") return pl_other_support_link_text(inputs)
	if (locale === "pt") return pt_other_support_link_text(inputs)
	if (locale === "ro") return ro_other_support_link_text(inputs)
	if (locale === "sk") return sk_other_support_link_text(inputs)
	if (locale === "sl") return sl_other_support_link_text(inputs)
	if (locale === "fi") return fi_other_support_link_text(inputs)
	if (locale === "sv") return sv_other_support_link_text(inputs)
	if (locale === "vi") return vi_other_support_link_text(inputs)
	if (locale === "tr") return tr_other_support_link_text(inputs)
	if (locale === "el") return el_other_support_link_text(inputs)
	if (locale === "bg") return bg_other_support_link_text(inputs)
	if (locale === "ru") return ru_other_support_link_text(inputs)
	if (locale === "sr") return sr_other_support_link_text(inputs)
	if (locale === "uk") return uk_other_support_link_text(inputs)
	if (locale === "ka") return ka_other_support_link_text(inputs)
	if (locale === "hi") return hi_other_support_link_text(inputs)
	if (locale === "th") return th_other_support_link_text(inputs)
	if (locale === "ko") return ko_other_support_link_text(inputs)
	if (locale === "zh") return zh_other_support_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_other_support_link_text(inputs)
	if (locale === "ja") return ja_other_support_link_text(inputs)
	return en_other_support_link_text(inputs)
});